import React, { useEffect,useState,useRef } from 'react';
import UEditor from '../../components/UEditor';
import {Form,Button,Input,message,Select,Modal,Divider,Upload,Progress,Cascader,Space,DatePicker,Checkbox,List,Image,ConfigProvider } from 'antd'
import Icon,{UploadOutlined,DeleteOutlined  } from '@ant-design/icons';
import UploadFile from '../../components/UploadFile';
import {getApiData} from "../../../request/api";
import checkLogin from '../../../request/checkLogin.js'


import './index.css'
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import 'moment/locale/zh-cn';
import AppConfig from '../../../app.config'
moment.locale('zh-cn')
const { RangePicker } = DatePicker;

const {Item} = Form
const { Option } = Select;

const uploadFileType = ".png, .jpg, .jpeg, .gif";

const screenWidth = document.body.clientWidth;
const screenHeight = document.body.clientHeight;

const allUpFiles = [
    // "https://awards.topdigitalworld.com/uploads/20231109/106370c66a70bba1a6c55fa712338f24.pdf",
    // "https://awards.topdigitalworld.com/uploads/20231109/1c90e7e8b2b27ae5b187ec525b863c86.mp4",
    // "https://awards.topdigitalworld.com/uploads/20231109/95deeafc41720b8ee643f5a819d2ef2e.png",
    // "https://awards.topdigitalworld.com/uploads/20231109/f1b5297e34c275299c2bbe44f9eb2ff9.png",
    // "https://awards.topdigitalworld.com/uploads/20231109/01faa0f925bed6d167acfdce2b743f8a.mp4",
];



function getDateStr(AddDayCount) {
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
    var year = dd.getFullYear();
    var mon = dd.getMonth() + 1; //获取当前月份的日期
    var day = dd.getDate();
    return year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day);
}

// 保存版本：0-草稿 1-正式
let saveVersion = 0;

const CREATE_TYPE_EDIT = 2;
const CREATE_TYPE_CREATE = 1
let saveData = {};
const PublishArticle = (props) => {
    const {showAddtc, modalinfo, rowInfo, gconfig, closeAddtc, refreshList} = props;
    console.log('showAddtc, modalinfo - ', showAddtc, modalinfo)
    console.log('rowInfo -', rowInfo);
    const [form] = Form.useForm();
    const ueRef = useRef(null)
    const ueRef2 = useRef(null)

    const [percent, setpercent] = useState({});
    const [percentShow,setPercentShow] = useState({});
    const [imageUrl,setImageUrl] = useState({});
    const [attpercent, setAttpercent] = useState(0);
    const [attpercentShow,setAttpercentShow] = useState(false);
    const [attachmentList,setAttachmentList] = useState([]);
    const [catOptions, setCatOptions] = useState([]);
    const [template, setTemplate] = useState({base:[], offer:[]});
    const [showTip, setShowTip] = useState(false);
    const [scoreStanderd, setScoreStanderd] = useState([]);
    const [agree, setAgree] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [curVideoUrl, setCurVideoUrl] = useState(false);
    const [loading, setLoading] = useState(false);

    /* add by jerry */
    const [tcid, setTcid] = useState("");//作品的 id，用来单独记录
    const [autosave, setAutoSave] = useState(false);//自动保存的状态标识，默认 false，即未开始第一次的自动保存，进行第一次保存后永远为 true
    const [createType, setCreateType] = useState(CREATE_TYPE_CREATE); //当前的编辑模式：1 -- 创建 2 -- 编辑
    //const [saveData, setSaveData] = useState({});//待保存的数据，在 Form字段更新时临时保存该数据


    let autosaveIntervalHandle = undefined;
    let autoSaveLastTime = new Date().valueOf();

    useEffect(() => {
        if(autosaveIntervalHandle) clearInterval(autosaveIntervalHandle);
        if(showAddtc){
            window.UE._CUR_PLATFORM = "U";

            console.group("--- useEffect ---");
            console.log(rowInfo);
            console.groupEnd();

            var pid = rowInfo.categoryid;

            var templateid = "";
            if(modalinfo.tid){
                setTemplate(modalinfo.template);
                pid = modalinfo.catid;
                templateid = modalinfo.tid;

            }
            else if(rowInfo.detail){//编辑
                setCreateType(CREATE_TYPE_EDIT);//设置当前为编辑模式
                setTcid(rowInfo.id);
                console.log("这是编辑模式", rowInfo.id);

                templateid = rowInfo.templateid;
                setTemplate(rowInfo.detail);
                try {
                    for(let item of rowInfo.detail.base){
                        // console.log('item------------------',item)
                        var myvalue = item.myvalue;
                        if(!myvalue)
                            continue;
                        if(item.type == 'select_category')
                            pid = item.myvalue[0];
                        else if(item.type == 'range')
                            myvalue = [moment(item.myvalue[0]), moment(item.myvalue[1])];
                        else if(item.type == 'upload'){
                            var imgt = imageUrl;
                            imgt[item.name] = myvalue;
                            setImageUrl(imgt);
                        }
                        form.setFieldValue(item.name, myvalue);
                    }
                    for(let item of rowInfo.detail.offer){
                        var myvalue = item.myvalue;
                        if(!myvalue)
                            continue;
                        if(item.type == 'select_category')
                            pid = item.myvalue[0];
                        else if(item.type == 'range')
                            myvalue = [moment(item.myvalue[0]), moment(item.myvalue[1])];
                        else if(item.type == 'upload'){
                            var imgt = imageUrl;
                            imgt[item.name] = myvalue;
                            setImageUrl(imgt);
                        }
                        form.setFieldValue(item.name, myvalue);
                    }
                    var list = [];
                    for(let type in rowInfo.detail.attach){
                        for(let url of rowInfo.detail.attach[type])
                            list.push({type:type, url:url});
                    }
                    setAttachmentList(list);
                }catch(error){
                    console.log('catch-error1 ---------- ', error)
                }
            }
            if(pid && catOptions.length == 0){
                getCatOptions(pid);
            }
            if(templateid)
                getScoreStanderd(templateid);

        } else {
          setpercent({});
          setPercentShow({});
          setImageUrl({});
          setAttpercent(0);
          setAttpercentShow(false);
          setAttachmentList([]);
          setCatOptions([]);
          setTemplate({base:[], offer:[]});
          saveVersion = 0;
          setLoading(false);

          setTcid("");//作品的 id，用来单独记录
          setAutoSave(false);//自动保存的状态标识，默认 false，即未开始第一次的自动保存，进行第一次保存后永远为 true
          setCreateType(CREATE_TYPE_CREATE); //当前的编辑模式：1 -- 创建 2 -- 编辑
      
          form.resetFields();
          saveData = {};
        }
      }, [showAddtc, rowInfo]);
  
    const getScoreStanderd = async(templateid)=>{
        try {
            return await getApiData('U', 'U_getScoreStanderd', {templateid:templateid}).then((res) => {
            console.log('U_getScoreStanderd-res-----------------', res);
            var flag = checkLogin('U', res.data)
            if (flag) {
                setScoreStanderd(res.data.d.list)
            }
            });
        } catch (error) {
            
            return false;
        }
    }

    const sortCategory = (list) => {
        console.log('catlist - ', list);
        list.sort((a, b) => a.name.localeCompare(b.name));
        console.log('catlist -- ', list);
        for(let key in list){
            if(list[key].children){
                console.log('catlist 2- ', list[key].children)
                sortCategory(list[key].children)
                console.log('catlist 2-- ', list[key].children)
            }
        }
    }
    //获取参赛组别
    const getCatOptions = (pid) => {
        try {
            getApiData('U', 'U_getCategory', {pid:pid}).then(async(res) => {
            console.log('U_getCategory-res-----------------', res);
            var flag = checkLogin('U', res.data)
            if (flag) {
                // setCatOptions([res.data.d.list]);
                var catlist = [res.data.d.list];
                // console.log('catlist: ',catlist)
                await sortCategory(catlist);
                // console.log('catlist: ',catlist)
                setCatOptions(catlist);
            }
            });
        } catch (error) {
            console.log('catch-error2 ---------- ', error)
            // return false;
        }
        
    };

    const onChangeAgree = (e) => {
        setAgree(e.target.checked);
    };





    const tailLayout = {
        wrapperCol: { offset: 10, span: 8 },
    };
    const [radioVal, setRadioVal] = useState(1)
    //编辑器的宽度
    const [config] = useState({
        initialFrameWidth: '100%',
        initialFrameHeight: 500
    })
    //编辑器的默认值
    const [initData] = useState('')
    //富文本失焦就触发setContent函数设置表单的content内容
    const setContent = (name,e)=>{
        var value = {};
        value[name] = e;
        form.setFieldsValue(value)
    }
    const [initData2] = useState('')
    //富文本失焦就触发setContent函数设置表单的content内容
    const setContent2 = (e)=>{
        form.setFieldsValue({
            content2: ueRef2.current.getUEContent()
        })
    }

     //发布(字段没填写完整)
    const onFinishFailed = async (e) => {
        // console.log(e.errorFields[0].name)
        if(saveVersion == 0){
            //await addeditCase(e.values);
            //add by jerry,保存草稿已经改成不需要提交表单了应该不会走到这个逻辑

            await SaveCase(e.values);
        } else if(saveVersion == 1) {
            // form.scrollToField(e.errorFields[0].name) // 滚动到对应字段位置
            setTimeout(()=>{
                document.querySelector('.ant-form-item-has-error')?.scrollIntoView({behavior: 'smooth', block: 'center'});
            }, 100)
        }
    }



    const OnSomeValuesChanges = async (changedValues, allValues)=>{
        //setSaveData(allValues);

        // 自动保存以草稿形式
        saveVersion = 0;

        saveData = allValues;

        console.group("--- OnSomeValuesChanges ---")
        console.log(changedValues);
        console.log(allValues);
        console.log(saveData);

        console.groupEnd();

        let localTM = new Date().valueOf();
        let isFirstSave = !autosave;
        if(localTM - autoSaveLastTime > 5*1000){
            console.log("准备自动保存")
            autoSaveLastTime = new Date().valueOf();
            if(createType === CREATE_TYPE_CREATE && isFirstSave === true){
                //在创建模式下第一次自动保存,需要提交数据并获得 id
                //await addeditCase(allValues, false,  true);
                await SubmitCase();
            } else{
                //await addeditCase(allValues, false, isFirstSave);
                await SaveCase(saveData);
            }
            setAutoSave(true);// 设置为自动保存已经开始
        }

    }
     //发布
    const onFinish = async (values) => {

        if(saveVersion==1 && !agree){
            message.warn("请先阅读《用户作品提交协议书》");
            return;
        }
        await SaveCase(values,true, "提交成功");
        // await addeditCase(values);
    };

    const SubmitCase = async (close=false, ShowMsg, )=>{
        const f = "U_createCase";
        const p = await InitPostResqParams(saveData);
        const respData = await SendRequest(f, p);
        if(respData.c === 0){
            if(typeof respData.d.id === "number"){
                setCreateType(CREATE_TYPE_EDIT);//设置当前为编辑模式
                setTcid(respData.d.id);
            }
        }else{
            message.error("提交失败!")
        }
    }
    const SaveCase = async (saveData, close=false, ShowMsg)=>{
        const f = "U_createCase";
        const p = await InitPostResqParams(saveData);
        const respData = await SendRequest(f, p);
        if(respData.c === 0){
            if(typeof respData.d.id === "number"){
                setTcid(respData.d.id);
            }
            if(ShowMsg) message.success(ShowMsg);
            if(close) setTimeout(()=>{ closeAddtc();refreshList();}, 1500);
        }else{
            console.log(respData.m)
            message.error(`保存失败,原因【${respData.m}】`)
        }
        return ;
    }

    /**
     * add by jerry
     * @returns {Promise<{}>}
     * @constructor
     */
    const InitAttachFields = async ()=>{

        let attch = {};
        for(let item of attachmentList){
            if(attch[item.type] == undefined)
                attch[item.type] = [];
            attch[item.type].push(item.url);
        };
        return attch
    }

    /**
     * add by jerry
     * @param values
     * @returns {Promise<void>}
     * @constructor
     */
    const InitPostResqParams = async (values)=>{
        const attch =  await InitAttachFields();
        const p = {
            caseid:tcid,
            templateid : modalinfo.tid,
            name: values.name,
            categoryid: values.category ? values.category[values.category.length-1] : "",
            content: values,
            attach: {
                PDF: attch.PDF ? attch.PDF : [],
                VIDEO: attch.VIDEO ? attch.VIDEO : [],
                PIC: attch.PIC ? attch.PIC : []
            },
            version: saveVersion
        };
        return p;
    }
    const SendRequest = (f, p)=>{
        return new Promise(async (resolve)=>{
            let ret = await getApiData('U', f, p).then(res =>{
                resolve(res.data);
            });
        })
    }


     //添加/修改案例
    /**
     *
     * @param values
     * @param flushList
     * @param needSubmit 是否需要提交
     * @returns {Promise<boolean>}
     */
    const addeditCase = async (values, flushList=true, needSubmit=false) => {
        let attch = await InitAttachFields();

        try {
            var f = "U_createCase";
            if(needSubmit) {
                f = "U_createCase";
            }else{
                f = "U_editCase";
            }

            var p = {
                templateid : modalinfo.tid,
                name: values.name,
                categoryid: values.category ? values.category[values.category.length-1] : "",
                content: values,
                attach: {
                    PDF: attch.PDF ? attch.PDF : [],
                    VIDEO: attch.VIDEO ? attch.VIDEO : [],
                    PIC: attch.PIC ? attch.PIC : []
                },
                version: saveVersion
            };
            if(f === "U_editCase"){
                //p.caseid = rowInfo.id;
                p.caseid = tcid;
            }
            setLoading(true);
            await getApiData('U', f, p).then((res) => {

                let respData = res.data;
                if(respData.c === 0){
                    setLoading(false);
                    if(typeof respData.d.id === "number"){
                        setTcid(respData.d.id);
                    }

                    var flag = checkLogin('U', res.data)
                    if (flag) {
                        if(saveVersion == 1){
                            message.success("提交成功");
                            closeAddtc();
                        }else{
                            if(autosaveIntervalHandle) clearInterval(autosaveIntervalHandle);
                            message.success("保存成功");
                        }


                        if(flushList) refreshList();
                        // window.location.reload();
                    }
                }else{
                    setLoading(false);
                    message.error(respData.m);
                }

            });
            } catch (error) {
                message.error("网络异常");
                setLoading(false);
                console.log('error ---- ', error)
                return false;
            }
        // message.error('发布未成功')
    };
    
    
    const showItems=(key)=>{
        if(!template)
            return;
        if(!template.hasOwnProperty(key))
            return;

        return template[key].map(item=>{
            // console.log('111111111111111111111111111111 - ', item)
            var desc = '';
            if(item.desc)
                desc = (<div style={{color:'rgb(41,136,231)',fontSize:'12px',lineHeight: '20px',paddingTop:10,width:"110%"}}>*{item.desc}</div>);
                // desc = (<div style={{color:'#b100ff',fontSize:'12px',lineHeight: '20px',paddingTop:10,width:"110%"}}>*{item.desc}</div>);
            if(item.type == 'upload')
                return (
                    <Item id={item.name} name={item.name} rules={[{required: true, message: '请上传' + item.title}]}>
                        <div style={{display:"flex"}}>


                        <span style={{width: "100px"}}>{item.title}</span>
                        <UploadFile
                            from={"U"}
                            upButton={<Button icon={<UploadOutlined/>} type="primary" shape='round' style={{
                                color: "white",
                                backgroundColor: "rgb(231,76,60)",
                                borderColor: "rgb(231,76,60)"
                                // backgroundColor: "rgb(152,100,201)",
                                // borderColor: "rgb(152,100,201)"
                            }}>上传</Button>}
                            uploadFileType={".png, .jpg, .jpeg, .gif"}
                            uploadFileSize={5 * 1024 * 1024}
                            setpercent={(v) => {
                                setpercent({...percent, [item.name]: v});
                            }}
                            setPercentShow={(v) => {
                                setPercentShow({...percentShow, [item.name]: v});
                            }}
                            setFileUrl={(v) => {
                                setImageUrl({...imageUrl, [item.name]: v});
                                form.setFieldValue(item.name, v);
                                saveData[item.name] = v;
                            }}
                            show={showAddtc}
                            upname={item.name}
                        />
                        </div>
                        <Progress percent={percent[item.name]} style={{
                            marginTop:"25px",
                            width: '80%',
                            top: -30,
                            left: 100,
                            display: percentShow[item.name] ? 'block' : 'none'
                        }}/>
                        {/* <img src={imageUrl.logo} height={100} style={{display: imageShow.logo==true?'block':'none'}} /> */}
                        {imageUrl[item.name] ? (
                            <div style={{
                                height: 100,
                                width: "fit-content",
                                textAlign: "center",
                                marginTop: 5,
                                overflow: "hidden"
                            }}>
                                <Image
                                    height={75}
                                    src={imageUrl[item.name]}
                                />
                                <br/>
                                <Button danger type='primary'
                                        style={{width: "100%", height: 18, borderRadius: 3, marginBottom: 5}}
                                        icon={<DeleteOutlined style={{fontSize: 10}}/>}
                                        onClick={() => {
                                            setpercent({...percent, [item.name]: 0});
                                            setPercentShow({...percentShow, [item.name]: false});
                                            setImageUrl({...imageUrl, [item.name]: ""});
                                            form.setFieldValue(item.name, "");
                                            saveData[item.name] = "";
                                        }}/>
                            </div>
                        ) : ""}
                        {desc}
                    </Item>
                )
            else if (item.type == 'text'){
                let rules = [{required: true, message: '请输入'+item.title}];
                if(item.selectdata != undefined){
                    rules.push({max:parseInt(item.selectdata[0]),message: item.title+'最多'+item.selectdata[0]+'字'})
                }
                return (
                    <Item id={item.name} name={item.name}  extra={desc} rules={rules}>
                        <div style={{display:"flex"}}>
                            <span style={{width: "100px"}}>{item.title}</span>
                            <Input style={{marginLeft:"10px"}} defaultValue={item.myvalue} allowClear />
                        </div>
                    </Item>
                )
            }
            else if(item.type == 'select_category'){
                return (

                    <Item id={item.name} name={item.name} extra={desc}
                          rules={[{required: true, message: '请选择' + item.title}]}>
                        <div style={{display: "flex"}}>
                            <span style={{width: "100px"}}>{item.title}</span>
                            <Form.Item
                                name={item.name}
                                initialValue={item.myvalue}
                                noStyle
                            >
                            <Cascader options={catOptions} allowClear={false} placeholder="请选择" style={{marginLeft:"10px"}}
                                      fieldNames={{
                                          label: 'name',
                                          value: 'cid',
                                          children: 'children',
                                      }}
                                      defaultValue={item.myvalue}/>
                            </Form.Item>
                        </div>
                    </Item>

            )
            } else if (item.type == 'range')
                return (
                    <Item id={item.name} name={item.name} extra={desc}
                          rules={[{required: true, message: '请选择' + item.title}]}>
                        <div style={{display: "flex"}}>
                            <span style={{width: "100px"}}>{item.title}</span>
                            <Form.Item
                                name={item.name}
                                initialValue={item.myvalue}
                                noStyle
                            >
                            <RangePicker format={"YYYY-MM-DD"}
                                         allowClear={false} locale={locale}

                            />
                            </Form.Item>
                        </div>
                    </Item>
        )
        else if(item.type == 'select_custom')
        return (
            <Item id={item.name} name={item.name} extra={desc}
                  rules={[{required: true, message: '请选择' + item.title}]}>
                <div style={{display: "flex"}}>
                    <span key={new Date().valueOf()} style={{width: "100px"}}>{item.title}</span>
                    <Form.Item
                        name={item.name}
                        initialValue={item.myvalue}
                        noStyle
                    >
                    <Select
                        placeholder="请选择"

                    >
                        {item.selectdata ? item.selectdata.map(one => {
                            return (<Option value={one}>{one}</Option>)
                        }) : []}

                    </Select>
                    </Form.Item>
                </div>


            </Item>
        )
            else if (item.type == 'editor')
                return (
                    <Item  id={item.name} name={item.name}  label={item.title} extra={desc} rules={[{required: true, message: '请输入'+item.title}]}>
                            <UEditor id={item.name}
                                     ref={ueRef} config={config} show={showAddtc}
                                     initData={rowInfo.detail?item.myvalue:""}
                                     setContent={(e)=>setContent(item.name, e)}></UEditor>
                    </Item>
                )
        })
    }
  

    const onChangeGroup = (value) => {
        console.log(value);
      };

    const attachmentListAdd = (type, value) => {
        var list = attachmentList;
        list.push({type:type, url:value})
        setAttachmentList(list);
        setAttpercentShow(false);
        setAttpercent(0)
    };

    const attachmentListDel = (value) => {
        var list = attachmentList;
        list = list.filter(item => item != value);
        setAttachmentList(list);
    };

    const CustomEmptyList = () => (
        // 这里面就是我们自己定义的空状态
        <span></span>
    )

    const  Attshowimage = (item) => {
        // var  ext = item.substring(item.lastIndexOf('.') + 1, item.lenght);
        // console.log('item----------------------',item);
        if(item.type == 'PDF')
            return ( <img src={[require("../../../img/pdf.png")]} alt="" width={80}  onClick={()=>{view(item.url,"pdf")}} />);
        else if(item.type == 'VIDEO')
            return ( <img src={[require("../../../img/mp4.png")]} alt="" width={80}  onClick={()=>{view(item.url,"video")}} />);
            // return ( <img src={[require("../../../img/mp4.png")]} alt="" width={80} onClick={()=>{setCurVideoUrl(item.url);setShowModal(true);}}  />);
        else
            return (
                <Image
                    // width={200}
                    height={80}
                    src={item.url}
                    preview={false}
                    onClick={()=>{view(item.url,"pic")}}
                    // fallback="data:image/png;base64,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"
                />
        )
    }
  
    // 打开附件PDF或图片在线预览
    const view = async(url, type)=>{
        try {
            return await getApiData('U', 'U_viewAttach', {"url":url,"type":type}).then((res) => {
              console.log('U_viewAttach-res-----------------', res);
              var flag = checkLogin('U', res.data)
              if (flag) {
                window.open(res.data.d.url);
              }
            });
          } catch (error) {
            
            return false;
          }
      }
    
    return (
        // console.log('percent - --------', percentShow, percent, imageUrl),
        <div className="PublishArticle-wrap" style={{display: showAddtc ? "" : "none"}}>
            <Form
                style={{width: '90%', paddingTop: 0}}
                autoComplete="off"
                form={form}
                onFinish={onFinish}
                labelAlign={'left'}
                labelCol={{span: 4}}
                layout="vertical"
                onValuesChange={OnSomeValuesChanges}
                scrollToFirstError={true}
                onFinishFailed={onFinishFailed}

            >
                <div className="add_title">基本信息</div>
                <Divider className='add_divide'/>
                {showItems("base")}

                <div className="add_title">作品描述</div>
                <Divider className='add_divide'/>
                {showItems("offer")}

                <div className="add_title">上传附件</div>
                <Divider className='add_divide'/>
                <div className='divfj'>
                    <div className='sbutt'>上传附件</div>
                    <div className="divfj-x">
                        <div style={{borderLeft: 0, position: "relative"}} className="divfj-xy">
                            {
                                attpercentShow ? <img src={[require("../../../img/pdf.jpg")]} alt=""
                                                      className='divfj-xy-1 not-allowed'/> :
                                    <UploadFile
                                        from={"U"}
                                        upButton={<img src={[require("../../../img/pdf.jpg")]} alt=""
                                                       className='divfj-xy-1'/>}
                                        uploadFileType={".pdf"}
                                        uploadFileSize={50 * 1024 * 1024}
                                        setpercent={setAttpercent}
                                        setPercentShow={setAttpercentShow}
                                        setFileUrl={(url) => attachmentListAdd("PDF", url)}
                                        show={showAddtc}
                                    />
                            }
                            <div className="divfj-xy-2">PDF</div>
                            <div className="divfj-xy-3">pdf格式</div>
                            <div className="divfj-xy-4">文件大小限制: 50MB</div>
                        </div>
                        <div className="divfj-xy" style={{position: "relative"}}>
                            {
                                attpercentShow ? <img src={[require("../../../img/video.jpg")]} alt=""
                                                      className='divfj-xy-1 not-allowed'/> :
                                    <UploadFile
                                        from={"U"}
                                        upButton={<img src={[require("../../../img/video.jpg")]} alt=""
                                                       className='divfj-xy-1'/>}
                                        uploadFileType={".mp4"}
                                        uploadFileSize={500 * 1024 * 1024}
                                        setpercent={setAttpercent}
                                        setPercentShow={setAttpercentShow}
                                        setFileUrl={(url) => attachmentListAdd("VIDEO", url)}
                                        show={showAddtc}
                                    />
                            }
                            <div className="divfj-xy-2">视频</div>
                            <div className="divfj-xy-3">mp4格式</div>
                            <div className="divfj-xy-4">文件大小限制: 500MB</div>
                            <div className="divfj-xy-4">推荐尺寸：800PX*450PX</div>
                        </div>
                        <div className="divfj-xy" style={{position: "relative"}}>
                            {
                                attpercentShow ? <img src={[require("../../../img/picture.jpg")]} alt=""
                                                      className='divfj-xy-1 not-allowed'/> :
                                    <UploadFile
                                        from={"U"}
                                        upButton={<img src={[require("../../../img/picture.jpg")]} alt=""
                                                       className='divfj-xy-1'/>}
                                        uploadFileType={".png, .jpg, .jpeg, .gif"}
                                        uploadFileSize={5 * 1024 * 1024}
                                        setpercent={setAttpercent}
                                        setPercentShow={setAttpercentShow}
                                        setFileUrl={(url) => attachmentListAdd("PIC", url)}
                                        show={showAddtc}
                                    />
                            }
                            <div className="divfj-xy-2">图片</div>
                            <div className="divfj-xy-3">jpg.jpeg.gif.png</div>
                            <div className="divfj-xy-4">文件大小限制: 5MB</div>
                            <div className="divfj-xy-4">推荐尺寸：800PX*450PX</div>
                        </div>
                    </div>
                </div>
                <Progress percent={attpercent} strokeWidth={12}
                          style={{width: '50%', top: -130, left: "27%", display: attpercentShow ? 'block' : 'none'}}/>
                <ConfigProvider renderEmpty={CustomEmptyList}>
                    <List
                        grid={{
                            gutter: 10,
                        }}
                        bordered={false}
                        split={false}
                        dataSource={attachmentList}
                        style={{marginTop: 10}}
                        renderItem={(item) => (
                            // console.log('list-item ---------------', item),
                            <List.Item>
                                {/* <a href={item.url} data-url={item.url} target="_blank" className="thumbnail"> */}
                                {Attshowimage(item)}
                                {/* </a> */}
                                <Button danger type='primary' style={{width: "100%", height: 20, borderRadius: 3}}
                                        icon={<DeleteOutlined style={{fontSize: 10}}/>}
                                        onClick={() => attachmentListDel(item)}/>
                            </List.Item>
                        )}
                    />
                </ConfigProvider>
                <div>
                    <span className="hfoo">
                    <Space>
                    <Checkbox id="agree" checked={agree} onChange={onChangeAgree}></Checkbox> 我已阅读并同意<a
                        target="_blank" href={gconfig.caseagreement}><span
                        style={{color: "#a4080f"}}>《用户作品提交协议书》</span></a>
                    </Space>
                    </span>
                </div>

                <Item>
                    <div className="group-sub">
                        <Space size={30}>
                            <Button type="primary" htmlType="submit" loading={loading} onClick={async (evt) => {
                                saveVersion = 0;
                                //add by jerry
                                evt.preventDefault(); // 阻止表单提交
                                await SaveCase(saveData,true, "保存成功");
                            }} style={{
                                height: 35,
                                borderRadius: 5,
                                backgroundColor: "#a4080f",
                                borderColor: "#a4080f",
                                // backgroundColor: "rgb(152,100,201)",
                                // borderColor: "rgb(152,100,201)",
                            }}>
                                保存为草稿
                            </Button>
                            {/* <Button type="primary" htmlType="submit" onClick={async (evt) => {

                                evt.preventDefault(); // 阻止表单提交
                                if(tcid === "") {
                                    message.warn("还未保存无法预览");
                                } else{
                                    // window.open(`${AppConfig.USER_PREVIEW_ADDTC}${tcid}`)
                                    window.open(`${window.location.href.split("#/")[0]+"#/enter/detail/?id="}${tcid}`)
                                }
                            }} style={{
                                height: 35,
                                borderRadius: 5,
                                backgroundColor: "#a4080f",
                                borderColor: "#a4080f",
                            }}>
                                点击预览
                            </Button> */}
                            <Button type="primary" htmlType="submit" loading={loading} onClick={() => {
                                saveVersion = 1;
                            }} style={{
                                height: 35,
                                borderRadius: 5,
                                backgroundColor: "#a4080f",
                                borderColor: "#a4080f",
                                // backgroundColor: "rgb(152,100,201)",
                                // borderColor: "rgb(152,100,201)",
                            }}>
                                提交为正式作品
                            </Button>
                            <Button type="primary" style={{
                                width: 120,
                                height: 35,
                                borderRadius: 5,
                                backgroundColor: "#c1c1c1",
                                borderColor: "#c1c1c1",
                            }} onClick={() => {
                                closeAddtc();
                            }}>
                                取消
                            </Button>
                        </Space>
                    </div>
                </Item>
                {/* <div style={{fontSize:13, textAlign:"left"}}>您可免费提交≤{gconfig.freecasecnt}件作品参赛，若您提交作品超出{gconfig.freecasecnt}件，超出部分需支付{gconfig.casefee}元/件的报名费。</div> */}
            </Form>

            <div className="side-notice">
                <div className="side-btn" onClick={() => {
                    setShowTip(!showTip)
                }}>评审指标
                </div>
                {/* <div className="side-btn" onClick={()=>{setShowTip(!showTip)}}>评审指标&amp;作品要求</div> */}
                <div className="side-content" style={{display: showTip ? "block" : "none"}}>
                    <b style={{fontSize: 15, marginBottom: 10}}>评审指标：</b>
                    {
                        scoreStanderd.map(item => (
                            <p><b>{item.review}（{item.weight}%）:</b>{item.desc}</p>
                        ))
                    }

                </div>
            </div>
            <div className="side-notice1">
                <div className="side-btn" style={{background:"#FFCCDD"}} onClick={() => {
                    if(tcid === "") {
                        message.warn("还未保存无法预览");
                    } else{
                        window.open(`${window.location.href.split("#/")[0]+"#/enter/detail/?id="}${tcid}`)
                        // window.open(`${AppConfig.USER_PREVIEW_ADDTC}${tcid}`)
                    }

                }}>点击预览
                </div>

            </div>


            {/* 模板列表 */}
            <Modal
                key="modaltype"
                // title='修改备注'
                open={showModal}
                width={screenWidth * 0.6}
                centered
                //   style={{height:screenHeight*0.9, backgroundColor:"transparent"}}
                footer={false}
                onCancel={() => {
                    setCurVideoUrl("");
                    setShowModal(false);
                }}
            >
                <video src={curVideoUrl} controls="controls" width={"100%"} style={{marginTop: 10}}/>

            </Modal>

        </div>
    )
}

export default PublishArticle